<template>
  <v-card flat>
    <v-card-text>
      <v-list>
        <v-list-item class="grey lighten-3 rounded-lg">
          <v-list-item-content>
            <v-list-item-subtitle>Admissão</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold subtitle-1">{{
              formatarData(perfil.admissao)
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="grey lighten-3 rounded-lg mt-2">
          <v-list-item-content>
            <v-list-item-subtitle>Vendedor</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold subtitle-1">{{
              perfil.nomevendedor
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="grey lighten-3 rounded-lg mt-2"
          v-if="cliente.vendedor.validar_saldo"
        >
          <saldo-contrato-vendedor
            :codvendedor="cliente.vendedor.cod"
            :saldovendedor="cliente.vendedor.saldo_emis_contrato"
          />
        </v-list-item>

        <v-list-item
          class="grey lighten-3 rounded-lg mt-2"
          v-if="perfil.restricaojudicial > 0"
        >
          <v-list-item-content>
            <v-list-item-subtitle>Restrição Judicial</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold title red--text">{{
              formatarMoeda(perfil.restricaojudicial)
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatMoeda } from "@/global";
import moment from "moment";
import SaldoContratoVendedor from "../config-conta/SaldoContratoVendedor.vue";

export default {
  components: { SaldoContratoVendedor },
  props: {
    perfil: Object,
    cliente: Object,
  },
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    formatarData(value) {
      return moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<style>
</style>